import cn from 'clsx'
import SolidStarCircleIcon from 'components/Luxkit/Icons/solid/SolidStarCircleIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'

import { rem } from 'polished'
import React, { useMemo } from 'react'
import styled from 'styled-components'
import FormatCurrency from 'components/Common/FormatCurrency'
import { connect } from 'react-redux'

const MarkerContainer = styled.div`
  position: relative;
  border-radius: ${(props) => props.theme.borderRadius.M};
  padding: ${rem(4)} ${rem(8)};
  background-color: ${(props) => props.theme.palette.neutral.default.eight};
  box-shadow: ${(props) => props.theme.shadow.bottom.small};
  border: 1px solid ${(props) => props.theme.palette.neutral.default.four};

  &.active,
  &:hover
  {
    font-weight: ${(props) => props.theme.font.primary.weight.bold};
    background-color: ${(props) => props.theme.palette.brand.primary.darkest};
    border: 1px solid ${(props) => props.theme.palette.brand.primary.darkest};
    color: ${(props) => props.theme.palette.brand.primary.lightest};
  }
`

interface Props {
  isActive: boolean;
  isFlash: boolean;
  isVisited: boolean;
  bestPrice?: number;
  bestPriceDuration?: number;
  currentBudget: App.BusinessTraveller.BusinessBudget | undefined,
}

function BusinessTravellerPropertyPriceMarker(props: Props) {
  const {
    isActive,
    isFlash,
    isVisited,
    bestPrice,
    bestPriceDuration,
    currentBudget,
  } = props
  const withinBudget = useMemo(() => {
    return (currentBudget && bestPrice && bestPriceDuration) && bestPrice < (currentBudget.budget * bestPriceDuration)
  }, [bestPrice, bestPriceDuration, currentBudget])
  const icon = isFlash && <SolidStarCircleIcon size={isActive ? 'M' : 'S'} colour={withinBudget ? 'highlight-primary-normal' : 'exclusive'} />

  return (
    <MarkerContainer
      className={cn({
        active: isActive,
        visited: isVisited,
      })}
    >
      <BodyTextBlock startIcon={icon} variant={isActive ? 'large' : 'medium'}>
        {bestPrice ? <FormatCurrency value={bestPrice} format="roundedDollar" /> : 'Loading...'}
      </BodyTextBlock>
    </MarkerContainer>
  )
}

const mapStateToProps = (state: App.State) => {
  return {
    currentBudget: state.businessTraveller.businessMapBudget,
  }
}

export default connect(mapStateToProps)(BusinessTravellerPropertyPriceMarker)
